import { render } from "./GenericInfo.vue?vue&type=template&id=008374f0"
import script from "./GenericInfo.vue?vue&type=script&lang=js"
export * from "./GenericInfo.vue?vue&type=script&lang=js"

import "./GenericInfo.vue?vue&type=style&index=0&id=008374f0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__